'use strict'

/**
 * Good to know:
 * - The menu items are managed in entities/headers
 *
 * @type {[type]}
 */
var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')
var Tabs = require('src/behaviors/tabs')

var DevicesFilter = require('src/components/devices-filter')
var View = require('./view.js')
// var Search = require('./search.js')

var List = function () {
  var Controller = Marionette.Object.extend({
    initialize: function () {
      var self = this

      self.layout = self.getLayoutView()
      self.layout.on('render', function () {
        self.navigationRegion()
        self.accountRegion()
      })
      // self.layout.on('tab:switch', _.bind(self.onTabSwitch, self))
      // self.layout.on('render', function () {
      //   self.showFilter()
      // })
      App.rootLayout.showChildView('headerRegion', self.layout)
    },
    navigationRegion: function () {
      var self = this
      var headerMenuItems = App.globalChannel.request('header:entities')

      var navigationLayout = self.getNavigationView(headerMenuItems)

      navigationLayout.on('childview:navigate', function (args) {
        var url = args.options.model.get('url')
        Backbone.history.navigate(url, {trigger: true})
      })

      self.layout.showChildView('navigationRegion', navigationLayout)
    },
    accountRegion: function () {
      var self = this
      var user = App.globalChannel.request('user:entity:current')
      var accountLayout = self.getAccountView(user)


      self.listenTo(accountLayout, 'logout', () => {
        App.session.logout()
      })
      
      self.listenTo(accountLayout, 'settings', (ev) => {
        App.globalChannel.trigger('client-users:edit', {region: App.rootLayout.getRegion('dialogRegion'), model: user})
      })

      // console.log(user)
      self.layout.showChildView('accountRegion', accountLayout)
    },
    getAccountView: function (model) {
      return new View.AccountView({model: model})
    },
    getNavigationView: function (collection) {
      return new View.NavigationLayout({collection: collection})
    },
    getLayoutView: function (collection) {
      return new View.Layout({collection: collection})
    }
  })

  return new Controller()
}

module.exports = List



// WEBPACK FOOTER //
// ./js/modules/header/list/index.js